// source: https://blog.nodeswat.com/automagic-reload-for-clients-after-deploy-with-angular-4-8440c9fdd96c
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject, throwError } from 'rxjs';
import { ConfirmDialogService } from '@sharedComponents/dialogs/confirm-dialog/confirm-dialog.service';
import { UserService } from '@core/services/user.service';
import { environment } from '@env/environment';
import { TranslationService } from '@core/translation/translation.service';

@Injectable({providedIn: 'root'})
export class VersionCheckService {

    private currentBuildNumber = environment.appBuildNumber;

    private _hasNewVersion$ = new Subject<void>();

    private hasOpenDialog = false;

    public get hasNewVersion$(): Observable<void> {
        return this._hasNewVersion$.asObservable();
    }

    constructor(private http: HttpClient,
                private confirmDialogService: ConfirmDialogService,
                private userService: UserService) {
    }

    /**
     * Checks the version of frontend application in every set frequency
     * @param url
     * @param {number} frequency - in milliseconds, defaults to 5 minutes
     */
    public initVersionCheck(url: string = environment.appVersionCheckURL,
                            frequency: number = environment.appVersionCheckInterval): void {

        // comment this out to test it locally
        if (!environment.production) {
            return;
        }

        setInterval(() => this.checkVersion(url), frequency);
    }

    openUpdateDialog(disableClose = false): void {
        this.hasOpenDialog = true;
        this.confirmDialogService
            .setTheme('primary')
            .setTitle(TranslationService.translate('bcmErrors.versionCheck.newVersionTitle'))
            .setBody(TranslationService.translate('bcmErrors.versionCheck.newVersionBodyHtml', {firstName: this.userService.user.firstName}))
            .setNoButton(disableClose ? null : {text: TranslationService.translate('bcmErrors.versionCheck.notNow')})
            .setYesButton({text: TranslationService.translate('bcmErrors.versionCheck.loadNewVersion'), color: 'primary'})
            .setDialogConfig({disableClose})
            .openWithCallback(() => {
                this.hasOpenDialog = false;
                location.reload();
            });
    }

    /**
     * Will do the call and check if the hash has changed or not
     * @param url
     */
    private checkVersion(url): void {
        // timestamp these requests to invalidate caches
        this.http.get(url + '?t=' + Date.now())
            .subscribe(
                (response: { buildNumber: string, datetime: number, version: string }) => {
                    if (this.currentBuildNumber !== response.buildNumber) {
                        this._hasNewVersion$.next(undefined);
                    }
                },
                (err) => throwError(err)
            );
    }
}
